import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import { Form, Input, Button, Row, Divider, Typography, Space} from 'antd';
import { ArrowLeftOutlined} from '@ant-design/icons';
import { isValidVerificationCode } from '../../Validation';
import { useApp } from '../../context/app-context';
import { sendVerificationCode } from '../../services/AuthService';
import { verifyCode } from '../../services/UserService';
import './Auth.css';
import { useMessage } from '../../components/UI/MessageProvider';

const { Title, Text, Paragraph } = Typography;

export const VerifyCode = ({ enable2FA, setEnable2FA, ...props}) => {  

    const { dispatch } = useApp();
    const message = useMessage();

    const [sendCode, setSendCode] = useState(false);
    const [displayFailedAuth, setDisplayFailedAuth] = useState(false);
    const [displaySentMessage, setDisplaySentMessage] = useState(false);

    useEffect(() => {
        setSendCode(true);
    }, [])

    useEffect(() => {
        const send2FACode = (email) => {
            sendVerificationCode({email: email}).then((response) => {})
            if(displaySentMessage){
                message.success('A verification code has been sent to the email in our records.')
            }
            setSendCode(false);
        }

        if(sendCode){
            send2FACode(enable2FA?.email);
        }
    }, [sendCode])

    const resendCodeHandler = () => {
        setSendCode(true);
        setDisplaySentMessage(true);
    }

    const verify2FACode = (values) => {
        verifyCode({email: enable2FA.email, token: values.code}).then((response) => {
            if(response.success){
                dispatch({type: 'update-user', payload: enable2FA})
                dispatch({type: 'login', payload: true})
                message.success('Welcome back!', 5);
            } else {
                setDisplayFailedAuth(true);
            }
        })
    };

    return (
        <div className="verify-code-page">
            <Row>
                <Form
                    name="verify-code"
                    className="form-container"
                    autoComplete='off'
                    onFinish={(values) => verify2FACode(values)}
                    onValuesChange={() => { setDisplayFailedAuth(false)}}
                >
                    <Title level={1}>Verify your email</Title>
                    <Paragraph>
                        To ensure the security of your account, we've sent a one-time verification code to your email address. The code will expire after 30 minutes.
                    </Paragraph>
                    <Paragraph>Enter your 6-digit code:</Paragraph>

                    <Form.Item
                        name="code"
                        rules={[
                            { 
                                required: true, 
                                message: "Please enter verification code",
                            }, 
                            {
                                validateTrigger: 'onSubmit',
                                validator: (_, value) => {
                                    if(isValidVerificationCode(value)){
                                        return Promise.resolve();
                                    } else {
                                        return Promise.reject(new Error('Incorrect verification code.'));
                                    }
                                }
                            }
                        ]}
                    >
                        <Input 
                            size="large"
                            placeholder="xxxxxx"
                            style={{letterSpacing: 6, fontSize: 24, color: 'var(--primary-color)'}}
                            type='number'
                            className='no-spinner'
                            onInput={(e) => e.target.value = e.target.value.substring(0,6)}
                        />
                    </Form.Item>

                    <Form.Item>
                        <Button  
                            type="primary"
                            block 
                            htmlType="submit" 
                            className="btn-block"
                        >
                            Submit
                        </Button>
                    </Form.Item>
                    
                    { displayFailedAuth && 
                        <Row justify='center'>
                            <Text type='danger'>Invalid code. Please try again.</Text>
                        </Row>
                    }

                    <Form.Item>
                        <Row justify='center' style={{marginBottom: 8}}>
                            <Space direction='vertical' align='center'>
                                <Text>Didn't receive code? <Typography.Link onClick={() => resendCodeHandler()}><strong>Resend.</strong></Typography.Link></Text>
                            </Space>
                        </Row>
                        <Link to='../'>
                            <Button block type='link'>Back to Login</Button>
                        </Link>
                    </Form.Item>
                </Form>
            </Row>
        </div>
    )
}
